import { el } from "../../utils/dom.js";
import { store } from "../../state/store.js";
import { tpKey } from "../../core/tpKey.js";
import { filteredTransponders, programCount } from "../../core/filter.js";
import { renderDetailsRow } from "./detailsRow.js";
import { getIntermediateFrequencyMHz, getPolBandLabel } from "../../utils/sat.js";
import { getBitrateRowTitle, isHighBitrateTp } from "../../utils/bitrate.js";
import { appendButton, appendCell } from "../../utils/render.js";

export function renderTpTable() {
  const tbody = el("tpTbody");
  if (!tbody) return;

  const list = filteredTransponders();

  tbody.innerHTML = "";
  for (const tp of list) {
    const key = tpKey(tp);
    const isOpen = store.openDetails.has(key);
    const sel = store.selection.has(key);
    const star = store.starred.has(key);
    const highBitrate = isHighBitrateTp(tp);

    const tr = document.createElement("tr");
    if (highBitrate) {
      tr.classList.add("high-bitrate");
      tr.title = getBitrateRowTitle(tp);
    }

    appendCell(tr, tp.tp_name || tp.provider || key, { title: tp.tp_name || "" });

    const detailsCell = appendCell(tr, "", { className: "nowrap" });
    appendButton(detailsCell, {
      label: `${isOpen ? "▾" : "▸"} Details`,
      dataset: { act: "toggle_details", key },
    });

    appendCell(tr, tp.sat_pos || "", { className: "nowrap" });
    appendCell(tr, tp.frequency_MHz || "", { className: "nowrap" });
    appendCell(tr, getIntermediateFrequencyMHz(tp.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, getPolBandLabel(tp.pol, tp.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, tp.symbolrate_kSps || "", { className: "nowrap" });
    appendCell(tr, tp.dvb || "", { className: "nowrap" });
    appendCell(tr, tp.tsid_onid || (tp.tsid ? `${tp.tsid}/${tp.onid || ""}` : ""), { className: "nowrap" });
    appendCell(tr, programCount(tp), { className: "nowrap" });

    const actionsCell = appendCell(tr, "", { className: "nowrap" });
    const actions = document.createElement("div");
    actions.className = "actions";
    actionsCell.appendChild(actions);

    appendButton(actions, {
      label: sel ? "✓" : "＋",
      className: sel ? "primary" : "",
      title: "Auswahl",
      dataset: { act: "toggle_sel", key },
    });
    appendButton(actions, {
      label: star ? "★" : "☆",
      title: "Favorit",
      dataset: { act: "toggle_star", key },
    });

    tbody.appendChild(tr);
    if (isOpen) tbody.appendChild(renderDetailsRow(key, 11));
  }
}
